<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">お知らせ</h3>
      </v-card-title>

      <v-card-actions>
        <!-- <v-btn @click="load" class="btn-search">{{$t('app.buttons.search')}}</v-btn> -->
        <v-btn to="/bulletin/new" v-permit.SHARP_MB_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!=1"
          @click="edit"
          v-permit.SHARP_MB_EDIT
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length==0"
          @click="remove"
          v-permit.SHARP_MB_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.content }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      results: [],
      selected: [],
      loading: true,
      headers: [
        { text: 'Title', value: 'title', sortable: false },
        { text: 'Content', value: 'content', sortable: false }
      ],
      query: {},
      pagination: {
        rowsPerPage: 10,
        page: 1
      }
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    edit() {
      this.$router.push({
        path: '/bulletin/edit',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(i => {
              return this.$http.delete(`/bulletins/${i.id}`).catch()
            })
          ).then(() => {
            this.selected = []
            this.load()
            this.$message('', '削除成功')
          })
        }
      )
    },
    load() {
      this.loading = true
      this.$http.get('/bulletins', this.params()).then(res => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    back() {
      this.$router.go(-1)
    }
  },
  mounted() {},
  watch: {
    pagination() {
      this.load()
    }
  }
}
</script>
<style scoped>
</style>
